import { render, staticRenderFns } from "./FoodOrderInfo.vue?vue&type=template&id=22ab1d6e&scoped=true"
import script from "./FoodOrderInfo.vue?vue&type=script&lang=js"
export * from "./FoodOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./FoodOrderInfo.vue?vue&type=style&index=0&id=22ab1d6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab1d6e",
  null
  
)

export default component.exports